import { render, staticRenderFns } from "./SEOSection.vue?vue&type=template&id=13ec6b13"
import script from "./SEOSection.vue?vue&type=script&lang=js"
export * from "./SEOSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports